import { sb } from '../supabase.ts';

export function renderLoginPage(app: HTMLElement): void {
  app.innerHTML = `
    <div class="login-page-wrapper">
      <div class="login-card-premium">
        <div class="login-header-premium">
          <div class="login-icon-wrapper">
            <svg 
              width="60" 
              height="60" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="white" 
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round"
              style="margin: 0 auto;"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
          </div>
          <h1>Dashboard</h1>
          <p>Secure authentication Super Admin</p>
        </div>
        
        <div class="login-body-premium">
          <form id="loginForm">
            <div class="login-form-group">
              <label for="email">Email Address</label>
              <input type="email" id="email" class="login-input-premium" required placeholder="Enter your email">
            </div>

            <div class="login-form-group">
              <label for="password">Password</label>
              <input type="password" id="password" class="login-input-premium" required placeholder="Enter your password">
            </div>

            <div id="errorMsg" style="color:#e53e3e; font-size:13px; min-height:18px; margin-bottom:15px; text-align:center;"></div>
            
            <button type="submit" class="login-btn-premium">Sign In</button>
            
            <a href="#" class="login-forgot-link">Forgot Password?</a>
          </form>
        </div>
      </div>
    </div>
  `;

  const form = document.getElementById('loginForm') as HTMLFormElement;
  const errorMsg = document.getElementById('errorMsg')!;

  form.onsubmit = async (e) => {
    e.preventDefault();
    const email = (document.getElementById('email') as HTMLInputElement).value;
    const password = (document.getElementById('password') as HTMLInputElement).value;

    errorMsg.textContent = 'Authenticating...';
    const { error } = await sb.auth.signInWithPassword({ email, password });

    if (error) {
      errorMsg.textContent = error.message;
    } else {
      window.location.href = '/';
    }
  };
}
